import { DayFlag } from "../UI.js";
export function calculateFocusTarget(days, getModifiers, isSelected, lastFocused) {
  var focusTarget;
  var index = 0;
  var found = false;
  while (index < days.length && !found) {
    var day = days[index];
    var modifiers = getModifiers(day);
    if (!modifiers[DayFlag.disabled] && !modifiers[DayFlag.hidden] && !modifiers[DayFlag.outside]) {
      if (modifiers[DayFlag.focused]) {
        focusTarget = day;
        found = true;
      } else if (lastFocused !== null && lastFocused !== void 0 && lastFocused.isEqualTo(day)) {
        focusTarget = day;
        found = true;
      } else if (isSelected(day.date)) {
        focusTarget = day;
        found = true;
      } else if (modifiers[DayFlag.today]) {
        focusTarget = day;
        found = true;
      }
    }
    index++;
  }
  if (!focusTarget) {
    // return the first day that is focusable
    focusTarget = days.find(function (day) {
      var m = getModifiers(day);
      return !m[DayFlag.disabled] && !m[DayFlag.hidden] && !m[DayFlag.outside];
    });
  }
  return focusTarget;
}